export const getVideoId = (url: string) => {
	const regex =
		/(?:[?&]vi?=|\/embed\/|\/\d\d?\/|\/vi?\/|https?:\/\/(?:www\.)?youtu\.be\/)([^&\n?#]+)/
	const match = url.match(regex)
	if (match && match[1].length == 11) {
		return match[1]
	}
	return ""
}
